import { render, staticRenderFns } from "./TiposRegistro.vue?vue&type=template&id=474c63b6&scoped=true"
import script from "./TiposRegistro.vue?vue&type=script&lang=js"
export * from "./TiposRegistro.vue?vue&type=script&lang=js"
import style0 from "./TiposRegistro.vue?vue&type=style&index=0&id=474c63b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c63b6",
  null
  
)

export default component.exports